import { useQuery } from "convex/react";
import { api } from "$convex/convexApi";
import { useAuthIdentity } from "@/contexts/UserProfileContext";

export function usePaymentStatusReport() {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.aging.getPaymentStatusReport,
    authUserId ? { authUserId } : "skip",
  );
}

export function useAllPaymentPlans(status?: string) {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.paymentPlans.getAllPaymentPlans,
    authUserId
      ? { authUserId, ...(status && status !== "all" ? { status: status as any } : {}) }
      : "skip",
  );
}

export function useAccountingAuditLogs(action?: string, limit = 100) {
  return useQuery(
    api.accounting.getAccountingAuditLogs,
    { ...(action ? { action } : {}), limit },
  );
}

export function useUserFinancialSettings(userId?: string) {
  return useQuery(
    api.accounting.getUserFinancialSettings,
    userId ? { userId: userId as any } : "skip",
  );
}

export function usePaymentHistoryForUser(userId?: string, limit = 100) {
  return useQuery(
    api.accounting.getPaymentHistoryForUser,
    userId ? { userId: userId as any, limit } : "skip",
  );
}

export function usePointsBalanceForUser(userId?: string) {
  return useQuery(
    api.pointsLedger.getBalanceForUser,
    userId ? { userId: userId as any } : "skip",
  );
}

export function usePointsHistoryForUser(userId?: string, limit = 50) {
  return useQuery(
    api.pointsLedger.getHistoryForUser,
    userId ? { userId: userId as any, limit } : "skip",
  );
}

export function useOrdersForPointsAdjustment(userId?: string) {
  return useQuery(
    api.pointsLedger.getOrdersForPointsAdjustment,
    userId ? { userId: userId as any } : "skip",
  );
}

export function useOverduePaymentsForUser(userId?: string) {
  return useQuery(
    api.aging.getOverduePaymentsForUser,
    userId ? { userId: userId as any } : "skip",
  );
}

export function useHasActivePaymentPlan(userId?: string) {
  return useQuery(
    api.paymentPlans.hasActivePaymentPlan,
    userId ? { userId: userId as any } : "skip",
  );
}

export function usePointsToForfeit(orderId?: string) {
  return useQuery(
    api.aging.calculatePointsToForfeit,
    orderId ? { orderId: orderId as any } : "skip",
  );
}

export function useCashflowAR(startDate?: number, endDate?: number) {
  return useQuery(
    api.accounting.getCashflowAR,
    startDate && endDate ? { startDate, endDate } : "skip",
  );
}
